module.exports = __webpack_public_path__ + "88b1f1a2e3d0a589c4741397039a5384.pdf";